module.exports = __webpack_public_path__ + "img/waichuqingxiaojia.e9da0135.png";